import { RootState } from "@lxp-app/store/store";
import { useSelector } from "react-redux";
import Tour from "reactour";

interface Props {
  steps: { selector: string; content: string }[];
  isTourOpen: boolean;
  setIsTourOpen: (val: boolean) => void;
}

const CustomTourProvider = ({ steps, isTourOpen, setIsTourOpen }: Props) => {
  const isHitachiOrg = useSelector(
    (state: RootState) => state.UserInfoSlice.profile.isHitachiOrg
  );

  return (
    <Tour
      showCloseButton={true}
      startAt={0}
      steps={steps}
      isOpen={isTourOpen}
      accentColor={!isHitachiOrg ? "#00875d" : "#D40000"}
      onRequestClose={() => setIsTourOpen(false)}
      disableFocusLock={false}
      scrollDuration={500}
      scrollOffset={-100}
      onAfterOpen={() => {
        document.body.style.overflowY = "hidden";
      }}
      onBeforeClose={() => {
        document.body.style.overflowY = "auto";
      }}
      disableInteraction={true}
      goToStep={0}
      showButtons={true}
    />
  );
};

export default CustomTourProvider;
